// src/firebase/firebase.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth,setPersistence,  browserSessionPersistence} from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyBRgdMDRIZzaQ-S7WcN14CLEYUXkw18o24",
    authDomain: "marshal-softwares.firebaseapp.com",
    projectId: "marshal-softwares",
    storageBucket: "marshal-softwares.firebasestorage.app",
    messagingSenderId: "918889492457",
    appId: "1:918889492457:web:cb91f6a54ae5c41b15a578",
    measurementId: "G-SHVJ0Z1X9Z"
  };
  
  // Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Initialize Firestore
const auth = getAuth(app); // Initialize Firebase Auth
setPersistence(auth, browserSessionPersistence);
const storage = getStorage(app);

export { db, auth, storage };
